import { ContextMenu } from "lib/@components/context-menu-bar"
import { RegisterItemEnd } from "routes/asset-register/register"
import { RegisterRowActionsMenu } from "./register-row-actions-menu"

export const AssetRegistersContextMenu = ContextMenu("assetRegisters")

RegisterItemEnd.plug(<RegisterRowActionsMenu $lazy />)
